<div class="container" aria-label="Main Content">

    <div class="row" id="main-content">
        <h2 class="text-center" tabindex="0">{{'COMMON.SESSION_TIMEOUT' | translate}}</h2>
    </div>
    <br />
    <div class="row">
        <h5 class="text-center" tabindex="0">{{'COMMON.RESTART_APPLICATION' | translate}}</h5>
    </div>
    <br />
    <div class="row">
        <button class="govuk-button restart-btn" (click)="restart()"
            tabindex="0">{{'COMMON.RESTART' | translate}}</button>
    </div>
</div>